import { useQuery } from '@tanstack/react-query';

import ParityNotificationsService from '~/services/ParityNotificationsService';

import { parityNotificationQueryKeys } from './parityNotificationQueryKeys';

export function useGetVendorOffers(vendorId: string, enabled: boolean) {
  return useQuery({
    queryKey: parityNotificationQueryKeys.vendorOffers(vendorId),
    queryFn: ({ signal }) => ParityNotificationsService.getVendorOffers(vendorId, signal),
    enabled,
    retry: false,
  });
}
